module.exports = __webpack_public_path__ + "static/media/audio-11-ru.a52d2f3b.mp3";